/* eslint-disable */
export default {
    questionnaire_research_questions_intro: "Avant de commencer votre programme, nous vous prions de bien vouloir remplir les champs ci-dessous.\n\nN.B. : Les informations que vous fournissez ci-dessous sont uniquement utilisées à des fins de recherche.",
    questionnaire_research_questions_title: "Bienvenue",
    questionnaire_research_questions_save: "Sauvegarder",
    questionnaire_page_title: "Questionnaire",
    questionnaire_go_back: "Retour",
    questionnaire_submit_questionnaire: "Sauvegarder et aller à l’aperçu",
    questionnaire_next: "Suivant",
    questionnaire_back: "Retour",
    questionnaire_nl_NL: "Néerlandais",
    questionnaire_en_GB: "English",
    questionnaire_finish: "Terminer",
    questionnaire_start: "Commencer",
    questionnaire_practice_question: "Question d’exercice",
    questionnaire_example_question: "Exemple de question",
    questionnaire_preparation_practice_questions_show_answer: "Afficher la réponse",
    questionnaire_continue: "Continuer",
    questionnaire_question: "Question",
    questionnaire_question_required_notification: "ATTENTION : Vous n'avez pas répondu à la question. Vous ne pourrez passer à la page suivante qu’après avoir répondu à la question.",
    questionnaire_instruction: "Consignes",
    questionnaire_route_to_overview: "Vers l'aperçu",
    questionnaire_could_not_retrieve_questionnaires: "Impossible de récupérer les questionnaires. Veuillez réessayer plus tard.",
    questionnaire_could_not_retrieve_psession: "Impossible de récupérer les données. Veuillez réessayer plus tard.",
    questionnaire_finish_screen_body: "<p>Vous avez répondu à toutes les questions, merci pour votre participation !</p><p>Si vous voulez changer quelque chose, vous pouvez retourner au questionnaire. Dans tous les autres cas, cliquez sur le bouton ci-dessous pour soumettre les réponses.</p><p><br></p><p><br></p>",
    questionnaire_of: "de",
    questionnaire_correct: "Correct",
    questionnaire_incorrect: "Inexact",
    questionnaire_maximum_answers_given: "Le nombre maximum de réponses a déjà été donné",
    questionnaire_dilemma_test_response_intro: "Indiquez maintenant l'importance de ces considérations dans les choix que vous avez faits. <br />Ces considérations s’affichent sur l'écran suivant.",
    questionnaire_de_DE: "Allemande",
    questionnaire_fr_FR: "Français",
    questionnaire_no_questionnaires_available: "There are currently no questionnaires available yet. These will be made available at a later stage.",
    questionnaire_update_answer_error: "Something went wrong while saving the answer, please try again later.",
    questionnaire_complete_questionnaire_error: "Something went wrong while completing the questionnaire, please try again later.",
    questionnaire_fetch_questionnaire_error: "Something went wrong while fetching the questionnaire, please try again later.",
    questionnaire_back_to_overview_cancelled: "This questionnaire has been cancelled.",
    questionnaire_back_to_overview_invalidated: "This questionnaire has been invalidated.",
    questionnaire_back_to_overview_finished: "This questionnaire has been completed.",
    questionnaire_return_to_overview_button: "Click here to return to the overview",
    questionnaire_back_to_overview_deadline_exceeded: "The deadline of this questionnaire has exceeded.",
    questionnaire_fetch_questionnaire_intro_error: "Something went wrong while fetching the introduction of the questionnaire, please try again later.",
    questionnaire_finish_screen_finish_button: "Finish",
    questionnaire_return_to_practice_site_button: "Return to the practice site",
    questionnaire_practice_feedback_text_a: "Votre note au test pratique:",
    questionnaire_practice_feedback_text_b: "sur",
    questionnaire_practice_verify_answers_error: "Something went wrong while verifying the answers, please try again later.",
    questionnaire_dilemma_test_see_case: "See case",
    questionnaire_answer_options: "Options de réponse",
    questionnaire_start_questionnaire_error: "Something went wrong while starting the questionnaire, please try again later.",
    questionnaire_dilemma_test_response_intro_case_dialog: "Indiquez maintenant l'importance de ces considérations dans les choix que vous avez faits.",
    questionnaire_time_left: "Temps restant",
    questionnaire_minutes_label: "minutes",
    questionnaire_practice_feedback_question: "Question",
    questionnaire_practice_feedback_correct: "Correct",
    questionnaire_practice_feedback_wrong: "Faux",
    questionnaire_finish_screen_practice_explanation_flow: "Vous avez répondu à toutes les questions, cliquez sur \"Terminer\" pour revenir au site d'entraînement",
    "questionnaire_show explanations_button": "Afficher les explications",
    questionnaire_not_answered_explanation_flow: "Cette question n'a pas reçu de réponse",
    questionnaire_show_explanations_button: "Afficher les explications"
};
